<div class="MainDiv">
  <div class="relative px-4 sm:px-6 lg:px-8 mx-auto w-full bg-white">
    <app-breadcrum [isProductList]="true" [partType]="isScrapPart ? 'Scrap Part' : 'Used Part'" [categoryName]="
        getSelectedSubcategory()?.name || getSelectedCategory()?.name
      "></app-breadcrum>
  </div>

  <section class="relative px-4 sm:px-6 lg:px-8 py-4 mx-auto w-full bg-white"
    *ngIf="selectedFilters?.categories?.length < 2">
    <h1 class="mb-4 text-lg sm:text-xl font-medium text-blue-950">
      Filter by {{ showSubcategories ? "Sub -" : "" }} Category
    </h1>

    <div class="relative">
      <!-- Top: Back button + selected category (shown only when a category is selected) -->
      <div *ngIf="selectedCategoryId !== null || categoryData" class="flex gap-3 items-center mb-3">
        <div
          class="flex-none flex items-center justify-center rounded-full bg-blue-100 cursor-pointer h-10 w-10 self-center"
          (click)="deselectCategory()">
          <img src="../../../assets/Icon Container.svg" alt="" />
        </div>
        <div
          class="p-2 bg-sky-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-Secondary-Blue inline-flex justify-center items-center gap-2 overflow-hidden cursor-pointer"
          (click)="deselectCategory()">
          <img class="w-8 h-6 relative"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/1a110801d1ffd0779665586f090d2d6c79081f32?placeholderIfAbsent=true"
            [alt]="getSelectedCategory()?.name" />
          <div
            class="justify-center text-Neutrals-Black text-sm font-bold leading-tight whitespace-nowrap max-md:text-xs">
            {{ getSelectedCategory()?.name }}
          </div>
        </div>
      </div>

      <!-- Separator line below selected category -->
      <hr *ngIf="selectedCategoryId !== null || categoryData" class="h-[2px] w-full bg-gray-300 my-2 shrink-0" />

      <!-- Carousel: categories or subcategories row below the line -->
      <div #carousel class="flex gap-4 overflow-x-auto sm:overflow-x-hidden scroll-smooth scrollbar-hide"
        (scroll)="onCarouselScroll()">
        <!-- Display all categories (or only non-selected ones if a category is selected) -->
        <article *ngFor="let category of getFilteredCategories()"
          class="flex-none cursor-pointer transition-all duration-300" (click)="
            showSubcategories
              ? selectSubcategory(category)
              : selectCategory(category)
          ">
          <!-- SCRAP CARD -->
          <div *ngIf="isScrapPart"
            class="category-card scrap-card w-[120px] sm:w-[160px] md:w-[199px] rounded-lg overflow-hidden bg-white shadow-sm"
            [ngClass]="{
              'border-2 border-blue-600':
                showSubcategories && isSubcategorySelected(category),
            }">
            <img [src]="
                category.image_url ||
                category.image ||
                'https://cdn.builder.io/api/v1/image/assets/TEMP/1a110801d1ffd0779665586f090d2d6c79081f32?placeholderIfAbsent=true'
              " [alt]="category.name" class="w-full h-[64px] sm:h-[72px] md:h-[80px] object-cover" loading="lazy" />
            <div class="flex items-center justify-between gap-1 px-1.5 py-1 sm:py-2 sm:px-2 bg-zinc-100">
              <span class="text-xs sm:text-sm font-bold text-black truncate">
                {{ category.name | slice: 0 : 20 }}
              </span>
              <span class="text-[10px] sm:text-xs text-neutral-600 whitespace-nowrap shrink-0"
                *ngIf="(category.partsCount || category.count) && !isMobile">
                {{ category.partsCount || category.count }} Items
              </span>
            </div>
          </div>

          <!-- USED PART CATEGORY CARD -->
          <div *ngIf="!isScrapPart"
            class="category-card used-card flex flex-col items-center justify-center rounded-lg cursor-pointer transition-all duration-300 w-[110px] sm:w-[160px] md:w-[199px] h-[96px] sm:h-[112px] p-2 overflow-hidden"
            [ngClass]="{
              'bg-blue-100 border-2 border-blue-600':
                showSubcategories && isSubcategorySelected(category),
              'bg-zinc-100': !(
                showSubcategories && isSubcategorySelected(category)
              ),
            }">
            <img [src]="
                category.image_url ||
                category.image ||
                'https://cdn.builder.io/api/v1/image/assets/TEMP/1a110801d1ffd0779665586f090d2d6c79081f32?placeholderIfAbsent=true'
              " [alt]="category.name" class="mb-1 sm:mb-2 w-[48px] sm:w-[62px] md:w-[83px] h-auto object-contain" />
            <div class="flex w-full px-1 sm:px-2 justify-between items-end gap-1">
              <span class="text-[11px] sm:text-sm font-bold text-black truncate">
                {{ category.name | slice: 0 : 20 }}
              </span>
              <span class="text-[10px] sm:text-xs text-neutral-600 whitespace-nowrap shrink-0"
                *ngIf="(category.partsCount || category.count) && !isMobile">
                {{ category.partsCount || category.count }} Parts
              </span>
            </div>
          </div>
        </article>
      </div>

      <!-- Navigation Buttons (only show on sm and up) -->
      <button *ngIf="canScrollLeftDirection()" (click)="scrollCarousel(-1)" [ngClass]="{
          'top-[120px]': showSubcategories,
          'top-1/2': !showSubcategories,
        }"
        class="hidden sm:flex absolute left-0 transform -translate-y-1/2 bg-white w-8 h-8 rounded-full shadow-md justify-center items-center z-10">
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2">
          <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <button (click)="scrollCarousel(1)" [ngClass]="{
          'top-[120px]': showSubcategories,
          'top-1/2': !showSubcategories,
        }"
        class="hidden sm:flex absolute right-0 transform -translate-y-1/2 bg-white w-8 h-8 rounded-full shadow-md justify-center items-center z-10">
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2">
          <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </section>

  <section class="relative overflow-hidden px-4 sm:px-6 lg:px-8 py-10 bg-white" *ngIf="toggleActive">
    <div class="flex gap-5 max-md:flex-col">
      <!-- Left sidebar with filters -->
      <aside class="w-full max-md:ml-0 max-md:w-full">
        <span class="self-start text-lg font-medium leading-none text-blue-950">
          Filter by Sub - Category
        </span>
        <div class="sm:flex gap-3 items-end max-md:mt-6 max-md:max-w-full">
          <div class="sm:flex sm:flex-col self-stretch">
            <div class="flex gap-3 mt-5 text-black tabletview">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/2c24d19c40a5b39b843b4f270f7d0a6722a07257?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                class="object-contain shrink-0 my-auto w-10 aspect-square" alt="Filter icon" />
              <article class="flex sm:overflow-hidden sm:flex-col sm:h-28 pt-1 bg-sky-100 rounded-lg"
                (click)="togglefilter()">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/541062116edc0f669eabf3779cf8716f39e01597?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  class="object-contain self-center w-10 h-10 sm:w-20 sm:h-20 aspect-[1.33]" alt="Engine" />
                <footer class="flex flex-wrap gap-10 justify-between items-end p-2">
                  <span class="text-sm font-bold leading-none">Engine</span>
                  <p class="text-xs font-medium leading-none" *ngIf="!isMobile">
                    2465 Parts
                  </p>
                </footer>
              </article>
            </div>
          </div>
          <div
            class="shrink-0 my-[10px] h-[1px] w-full sm:w-px sm:h-28 sm:mt-13 sm:my-0 border border-solid bg-neutral-300 border-neutral-300">
          </div>

          <div class="relative flex-grow">
            <section #scrollContainer
              class="flex overflow-x-auto gap-4 scroll-smooth no-scrollbar whitespace-nowrap w-full max-w-full">
              <div class="flex gap-4 min-w-fit">
                <article *ngFor="let category of categoriess"
                  class="flex-none relative flex flex-col justify-end overflow-hidden items-center h-28 rounded-lg w-[199px] max-md:h-[100px] max-md:w-[180px] max-sm:w-40 max-sm:h-[90px] cursor-pointer"
                  [ngClass]="category.backgroundColor || 'bg-zinc-100'" (click)="selectCategory(category)">
                  <img [src]="category.imageUrl"
                    class="object-contain self-center w-16 h-16 max-sm:w-14 max-sm:h-14 shrink-0"
                    [alt]="category.title" />
                  <footer class="flex justify-between items-end p-2 w-full shrink-0">
                    <span class="text-sm font-bold" [ngClass]="{
                        'leading-none': !category.multilineTitle,
                        'leading-5': category.multilineTitle,
                      }">
                      <ng-container *ngIf="!category.multilineTitle">{{
                        category.title
                        }}</ng-container>
                      <ng-container *ngIf="category.multilineTitle">
                        <span>
                          {{ category.title.split(" & ")[0] }}<br />
                          {{ category.title.split(" & ")[1] }}
                        </span>
                      </ng-container>
                    </span>
                    <!-- <p
                      class="text-xs font-medium leading-none"
                      *ngIf="category.partsCount && !isMobile && !isScrapPart"
                    >
                      {{ category.partsCount }}
                    </p> -->
                  </footer>
                </article>
              </div>
            </section>

            <!-- Navigation buttons -->
            <button (click)="scrollLeft()"
              class="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white w-8 h-8 rounded-full shadow-md flex justify-center items-center z-10 max-sm:hidden"
              aria-label="Previous" *ngIf="!isMobile">
              <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2">
                <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>

            <button (click)="scrollRight()"
              class="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white w-8 h-8 rounded-full shadow-md flex justify-center items-center z-10 max-sm:hidden"
              aria-label="Next" *ngIf="!isMobile">
              <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2">
                <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </aside>
    </div>
  </section>
  <header
    class="relative overflow-hidden px-4 sm:px-6 lg:px-8 bg-white flex flex-wrap items-center gap-1 text-sm md:text-base font-medium text-neutral-500">
    <h1 class="font-bold text-black mb-3">
      {{
      getSelectedCategory()?.name
      ? getSelectedCategory()?.name
      : isScrapPart
      ? "All Items"
      : "All Parts"
      }}
      -
      <span class="text-neutral-500">{{ productsCount }} {{ isScrapPart ? "Items" : "parts" }}</span>
    </h1>
    <!-- <span>-</span>
<span class="text-neutral-500">{{ productsCount }} parts</span> -->
  </header>
  <!-- parts-filter.component.html -->
  <app-filter (viewChanged)="onViewChange($event)" [data]="filterpassData"
    [partType]="isScrapPart ? 'Scrap Part' : 'Used Part'"></app-filter>

  <!-- Local skeleton while initial API is in-flight (prevents blank screen) -->
  <section *ngIf="isLoading && products.length === 0 && productData.length === 0" class="px-4 sm:px-6 lg:px-8 bg-white">
    <div class="prodList grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
      <div *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8]"
        class="border border-gray-100 rounded-lg overflow-hidden bg-white">
        <div class="aspect-[4/3] bg-gray-100 animate-pulse"></div>
        <div class="p-3 space-y-2">
          <div class="h-4 bg-gray-100 rounded animate-pulse w-5/6"></div>
          <div class="h-3 bg-gray-100 rounded animate-pulse w-2/3"></div>
          <div class="h-4 bg-gray-100 rounded animate-pulse w-1/2"></div>
        </div>
      </div>
    </div>
  </section>
  <!-- grid view of products -->
  <div class="relative mb-2 px-4 sm:px-6 lg:px-8" *ngIf="selectedView === 'grid' && products.length > 0">
    <section class="prodList grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
      <article *ngFor="let product of products; trackBy: trackByProductId"
        class="Flex product-card flex flex-col items-stretch bg-white rounded-lg overflow-hidden w-full h-full transition-all duration-300 ease-in-out border border-transparent hover:border-gray-100 hover:shadow-md hover:bg-gray-50 cursor-pointer">
        <div
          class="relative group w-full aspect-[4/3] sm:aspect-auto sm:h-[200px] lg:h-[231px] cursor-pointer overflow-hidden bg-zinc-100"
          (mouseenter)="onProductHover(product)" (mouseleave)="onProductHoverEnd()">
          <!-- Grade Badge -->
          <div *ngIf="product?.quality_s" [ngClass]="
              product?.quality_s === 'A'
                ? 'bg-green-100 text-green-800'
                : product?.quality_s === 'B'
                  ? 'bg-yellow-100 text-yellow-800'
                  : product?.quality_s === 'C'
                    ? 'bg-orange-100 text-orange-800'
                    : 'bg-green-100 text-green-800'
            " class="absolute top-2 left-2 z-10 flex items-center px-2 py-1 rounded shadow font-bold text-xs">
            <svg width="20" height="20" class="mr-1">
              <rect width="20" height="20" rx="4" [attr.fill]="
                  product?.quality_s === 'A'
                    ? '#01811D'
                    : product?.quality_s === 'B'
                      ? '#B8860B'
                      : product?.quality_s === 'C'
                        ? '#D35400'
                        : '#01811D'
                " />
              <text x="10" y="15" text-anchor="middle" font-size="12" font-family="Arial, sans-serif" fill="white">
                {{ product.quality_s }}
              </text>
            </svg>
            Quality
          </div>
          <div *ngIf="product?.stock_quantity_s <= 0"
            class="absolute gap-2 px-3 py-1 text-base font-bold leading-6 text-white rounded-lg opacity-80 bg-zinc-700 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-sm:text-sm text-ellipsis-1-line">
            out of stock
          </div>

          <!-- Left Arrow -->
          <button *ngIf="
              hoveredProduct === product && product?.part_image_path?.length > 1
            " (click)="prevImage(product)"
            class="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow group-hover:flex hidden">
            <svg width="24" height="24" fill="none" stroke="black" stroke-width="2">
              <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <!-- Product Image -->
          <img [src]="getCurrentImage(product)" [alt]="product | productName" (click)="gotoProductDetails(product)"
            class="ProdImg object-cover bg-zinc-100 w-full h-full rounded-none" />

          <!-- Right Arrow -->
          <button *ngIf="
              hoveredProduct === product && product?.part_image_path?.length > 1
            " (click)="nextImage(product)"
            class="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow group-hover:flex hidden">
            <svg width="24" height="24" fill="none" stroke="black" stroke-width="2">
              <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <!-- Carousel Dots -->
          <div *ngIf="
              hoveredProduct === product && product?.part_image_path?.length > 1
            " class="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1 z-10 group-hover:flex hidden">
            <span *ngFor="let img of product.images; let i = index" class="w-3 h-1.5 rounded-full" [ngClass]="{
                'bg-gray-400': i !== product.currentImageIndex,
                'bg-white border border-gray-400':
                  i === product.currentImageIndex,
              }"></span>
          </div>
        </div>
        <div class="flex flex-col gap-1.5 max-sm:gap-1 w-full flex-grow cursor-pointer p-2 sm:p-3">
          <span (click)="gotoProductDetails(product)"
            class="block text-sm sm:text-base font-bold text-black leading-5 sm:leading-6 line-clamp-2">
            {{ product | productName }}
          </span>

          <div (click)="gotoProductDetails(product)"
            class="flex flex-wrap gap-1 items-center text-[10px] sm:text-[11px] leading-[14px] text-neutral-600"
            *ngIf="!isScrapPart">
            <span *ngIf="product?.make">{{ product?.make }}</span>
            <span *ngIf="product?.make">•</span>
            <span *ngIf="product?.model">{{
              product?.model | slice: 0 : 10
              }}</span>
            <span *ngIf="product?.model">•</span>
            <span *ngIf="product?.year_of_manufacture">{{
              product?.year_of_manufacture
              }}</span>
            <span *ngIf="product?.year_of_manufacture">•</span>
            <span *ngIf="product?.variant">{{
              product?.variant | slice: 0 : 10
              }}</span>
          </div>

          <div (click)="gotoProductDetails(product)" class="flex flex-wrap gap-1.5 sm:gap-2 items-center"
            *ngIf="!isScrapPart">
            <span class="text-sm sm:text-base font-bold text-black whitespace-nowrap">
              ₹{{
              product?.discounted_price
              ? product?.discounted_price.toLocaleString()
              : product?.price_s.toLocaleString()
              }}
            </span>

            <span class="text-xs sm:text-sm font-medium line-through text-neutral-500 whitespace-nowrap" *ngIf="
                product?.discounted_price &&
                product?.price_s &&
                product?.discount_percentage > 0
              ">
              ₹{{ product?.price_s?.toLocaleString() }}
            </span>
            <div
              class="px-1.5 sm:px-2 py-0.5 h-5 sm:h-6 text-[10px] sm:text-xs font-bold text-white bg-emerald-800 rounded-2xl whitespace-nowrap"
              *ngIf="
                product?.discounted_price &&
                product?.price_s &&
                product?.discount_percentage > 0
              ">
              {{ product?.discount_percentage }}% Off
            </div>
          </div>

          <div class="flex flex-col gap-1 w-full" *ngIf="!isScrapPart">
            <div class="flex gap-1.5 items-center min-w-0">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="shrink-0 sm:w-5 sm:h-5">
                <path
                  d="M11.6666 15V8.33333M11.6666 15H13.3333M11.6666 15H8.74996M4.16663 15H5.41663M11.6666 8.33333V5.83333C11.6666 5.3731 11.2935 5 10.8333 5H4.16663C3.70639 5 3.33329 5.3731 3.33329 5.83333V7.5M11.6666 8.33333H15.1429C15.585 8.33333 16.0089 8.50893 16.3214 8.82149L17.8451 10.3452C18.1577 10.6577 18.3333 11.0817 18.3333 11.5237V14.1667C18.3333 14.6269 17.9602 15 17.5 15H16.6666M8.74996 15C8.74996 15.9205 8.00377 16.6667 7.08329 16.6667C6.16282 16.6667 5.41663 15.9205 5.41663 15M8.74996 15C8.74996 14.0795 8.00377 13.3333 7.08329 13.3333C6.16282 13.3333 5.41663 14.0795 5.41663 15M16.6666 15C16.6666 15.9205 15.9204 16.6667 15 16.6667C14.0795 16.6667 13.3333 15.9205 13.3333 15M16.6666 15C16.6666 14.0795 15.9204 13.3333 15 13.3333C14.0795 13.3333 13.3333 14.0795 13.3333 15M3.33329 7.5H6.66663M3.33329 7.5H1.66663M8.33329 10H3.33329M3.74996 12.5H2.49996"
                  stroke="#307FE1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <div class="flex flex-wrap gap-1 items-center min-w-0">
                <span class="text-[10px] sm:text-xs font-medium text-black">Delivery by</span>
                <span class="text-[10px] sm:text-xs font-bold text-black">{{
                  getDeliveryDate()
                  }}</span>
              </div>
            </div>
            <div class="flex gap-1.5 items-center min-w-0">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="shrink-0 sm:w-5 sm:h-5">
                <path
                  d="M16.0869 8.93384V15C16.0869 16.3807 14.919 17.5 13.4782 17.5H12.1739M16.0869 8.93384C16.4191 8.76991 16.7513 8.52197 17.035 8.27813C17.5483 7.83698 17.627 7.11852 17.3187 6.52752L15.9384 3.88197C15.4965 3.03501 14.5932 2.5 13.6051 2.5H6.3949C5.4068 2.5 4.50351 3.03501 4.06162 3.88197L2.68134 6.52752C2.373 7.11852 2.45168 7.83698 2.96498 8.27813C3.24869 8.52197 3.58089 8.76991 3.91309 8.93384M16.0869 8.93384C15.8016 9.07464 15.5051 9.16667 15.2174 9.16667C13.4782 9.16667 12.6087 7.5 12.6087 7.5C12.6087 7.5 11.7391 9.16667 10 9.16667C8.26088 9.16667 7.39132 7.5 7.39132 7.5C7.39132 7.5 6.52176 9.16667 4.78264 9.16667C4.49494 9.16667 4.19841 9.07464 3.91309 8.93384M3.91309 8.93384V15C3.91309 16.3807 5.08103 17.5 6.52176 17.5H7.8261M7.8261 17.5V13.3333C7.8261 12.8731 8.21542 12.5 8.69566 12.5H11.3043C11.7846 12.5 12.1739 12.8731 12.1739 13.3333V17.5M7.8261 17.5H12.1739"
                  stroke="#307FE1" stroke-width="1.5" stroke-linejoin="round"></path>
              </svg>
              <span class="text-[10px] sm:text-xs font-medium text-black">Store pickup ready</span>
            </div>
          </div>

          <!-- scrap product details -->
          <div *ngIf="isScrapPart">
            <div class="flex flex-col text-sm">
              <p class="justify-start text-Text-Black">
                <span class="text-[10px] sm:text-xs font-medium leading-none">{{ product?.scrap_category }}</span>
              </p>

              <p class="text-gray-600 text-xs sm:text-sm">
                Seller:
                <span class="text-[#0A0A5F] text-xs sm:text-[14px] font-bold leading-5 sm:leading-[30px]">{{
                  product?.seller_name }}</span>
              </p>
              <div (click)="gotoProductDetails(product)" class="flex flex-wrap items-center gap-1.5 sm:gap-2">
                <p class="text-black text-xs sm:text-[14px] font-bold leading-5 sm:leading-[30px]">
                  ₹{{
                  product?.discounted_taxable
                  ? product?.discounted_taxable
                  : product?.taxable_amount
                  }}/<ng-container *ngIf="product.isOilProduct; else showKgPrice">Liter</ng-container><ng-template
                    #showKgPrice>Kg</ng-template>
                </p>
                <p class="text-[#777] line-through text-[10px] sm:text-[12px] font-medium leading-[16px]" *ngIf="
                    product?.discounted_taxable &&
                    product?.taxable_amount &&
                    product?.discount_percentage > 0
                  ">
                  ₹{{ product?.taxable_amount?.toLocaleString() }}
                </p>
                <span
                  class="flex items-center justify-center gap-1 px-1.5 py-0.5 rounded-[13px] bg-[#006C3B] text-white text-[9px] sm:text-[10px] font-bold leading-[12.487px] whitespace-nowrap"
                  *ngIf="
                    product?.discounted_taxable &&
                    product?.taxable_amount &&
                    product?.discount_percentage > 0
                  ">
                  {{ product?.discount_percentage }}% Off
                </span>
              </div>
              <div class="flex flex-wrap items-center justify-between gap-1 text-[10px] sm:text-xs text-gray-500 mt-1 max-sm:mt-0.5">
                <p>
                  Min Booking Qty:
                  <span class="text-black text-xs sm:text-[14px] font-bold leading-5">
                    <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                      product?.min_quantity || product?.min_qty || 0
                      }}
                      kg</ng-container>
                    <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                      (product?.min_quantity || product?.min_qty || 0) / 1000
                      }}
                      ton</ng-container>
                    <ng-container *ngIf="product.selectedUnit === 'liter'">{{
                      product?.min_quantity || product?.min_qty || 0
                      }}
                      ltr</ng-container>
                  </span>
                </p>
                <p>
                  Max Booking Qty:
                  <span class="text-black text-xs sm:text-[14px] font-bold leading-5">
                    <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                      product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                      product?.available_quantity || 0
                      }}
                      kg</ng-container>
                    <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                      ((product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                      product?.available_quantity || 0) / 1000)
                      }}
                      ton</ng-container>
                    <ng-container *ngIf="product.selectedUnit === 'liter'">{{
                      product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                      product?.available_quantity || 0
                      }}
                      ltr</ng-container>
                  </span>
                </p>
              </div>

              <div class="product-card-qty-box mt-1 max-sm:mb-2">
                <!-- Quantity input/select based on unit -->
                <div *ngIf="
                    !product.selectedUnit || product.selectedUnit === 'ton'
                  " class="flex flex-1 min-w-0">
                  <!-- Show select dropdown when not in custom mode -->
                  <select *ngIf="product.quantity !== 'custom'" (change)="onTonQuantitySelect(product, $event)"
                    [value]="product.quantity || ''"
                    class="qty-dropdown">
                    <option value="">Select any one</option>
                    <option value="10" *ngIf="!product.isOilProduct">10</option>
                    <option value="15" *ngIf="!product.isOilProduct">15</option>
                    <option value="20" *ngIf="!product.isOilProduct">20</option>
                    <option value="25" *ngIf="!product.isOilProduct">25</option>
                    <option value="50" *ngIf="!product.isOilProduct">50</option>
                    <option value="custom" *ngIf="!product.isOilProduct">
                      Custom
                    </option>
                  </select>
                  <!-- Show input field when custom is selected -->
                  <input *ngIf="product.quantity === 'custom'" type="number" placeholder="Enter quantity"
                    [value]="product.customTonQuantity || ''" (input)="onCustomTonQuantityInput(product, $event)"
                    (blur)="onQuantityBlur(product)" [id]="'customInput-' + product.part_number"
                    class="qty-dropdown"
                    min="1" step="0.1" #customInput />
                </div>

                <div *ngIf="product.selectedUnit === 'kg'" class="flex flex-1 min-w-0">
                  <input type="number" placeholder="Enter quantity" [value]="product.customKgQuantity || ''"
                    (input)="onKgQuantityChange(product, $event)" (blur)="onQuantityBlur(product)"
                    class="qty-input" />
                </div>

                <div *ngIf="product.selectedUnit === 'liter'" class="flex flex-1 min-w-0">
                  <input type="number" placeholder="Enter quantity" [value]="product.customLiterQuantity || ''"
                    (input)="onLiterQuantityChange(product, $event)" (blur)="onQuantityBlur(product)"
                    class="qty-input" />
                </div>

                <!-- Divider -->
                <div class="unit-divider"></div>

                <!-- Unit select -->
                <select (change)="onUnitChange(product, $event)" [value]="product.selectedUnit || 'ton'"
                  class="unit-dropdown">
                  <option value="ton" *ngIf="!product.isOilProduct">ton</option>
                  <option value="kg" *ngIf="!product.isOilProduct">kg</option>
                  <option value="liter" *ngIf="product.isOilProduct">
                    ltr
                  </option>
                </select>
              </div>

              <!-- Error message for quantity validation -->
              <div class="w-fit max-sm:w-full max-sm:mb-2">
                <span *ngIf="
                    product.quantityTouched &&
                    (isScrapPart || product?.part_type === 'Scrap Part') &&
                    (getSelectedQuantity(product) === 0 ||
                      getSelectedQuantity(product) === null ||
                      getSelectedQuantity(product) === undefined)
                  " class="block mt-2 text-[10px] sm:text-xs text-red-600">
                  Please select a quantity
                </span>
                <span *ngIf="
                    product.quantityTouched &&
                    getSelectedQuantity(product) > 0 &&
                    getSelectedQuantity(product) <
                      (product.min_quantity || product.min_qty || 0)
                  " class="block mt-2 text-[10px] sm:text-xs text-red-600">
                  Minimum quantity is
                  <ng-container *ngIf="
                      product.selectedUnit === 'kg' || !product.selectedUnit
                    ">{{
                    product.min_quantity || product.min_qty || 0
                    }}
                    kg</ng-container><ng-container *ngIf="product.selectedUnit === 'ton'">{{
                    (product.min_quantity || product.min_qty || 0) / 1000
                    }}
                    ton</ng-container><ng-container *ngIf="
                      product.selectedUnit === 'liter' || product.isOilProduct
                    ">{{
                    product.min_quantity || product.min_qty || 0
                    }}
                    ltr</ng-container>
                </span>
                <span *ngIf="
                    product.quantityTouched &&
                    getSelectedQuantity(product) > 0 &&
                    getSelectedQuantity(product) >
                      (product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity || product.available_quantity || 0)
                  " class="block mt-2 text-[10px] sm:text-xs text-red-600">
                  Maximum available quantity is
                  <ng-container *ngIf="
                      product.selectedUnit === 'kg' || !product.selectedUnit
                    ">{{ product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                    product.available_quantity || 0 }} kg</ng-container><ng-container
                    *ngIf="product.selectedUnit === 'ton'">{{
                    ((product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                    product.available_quantity || 0) / 1000)
                    }}
                    ton</ng-container><ng-container *ngIf="
                      product.selectedUnit === 'liter' || product.isOilProduct
                    ">{{ product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                    product.available_quantity || 0 }} liter</ng-container>
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="product?.is_locked"
            class="flex items-center gap-2 text-[#E30613] text-[12px] font-bold max-md:text-[10px]">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16">
              <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />
              <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />
              <circle cx="16" cy="23" r="2" fill="red" />
            </svg>
            <span>This part is no longer available for purchase.</span>
          </div>

          <div class="BuyButton flex flex-row gap-1 xl:gap-2 items-stretch mt-auto pt-2 max-sm:pt-1.5 w-full">
            <!-- Buy Now Button -->
            <app-buy-now-button [productData]="product" [isLocked]="product?.is_locked"
              (buyNowClicked)="onBuyNow(product)" (paymentSuccess)="onPaymentSuccess($event)"
              class="flex-1 w-full min-w-0">
            </app-buy-now-button>

            <!-- Animated Cart Button -->
            <button [disabled]="product?.is_locked"
              class="cart-btn flex items-center justify-center gap-0.5 xl:gap-1 px-1 py-1.5 xl:px-2 xl:py-2 w-full flex-1 min-w-0 bg-blue-500 border border-[#307FE1] rounded-lg min-h-8 xl:min-h-10 text-[10px] md:text-[11px] xl:text-sm font-bold text-white overflow-hidden"
              [class.added]="itemAddedToCart.get(product?.inventory_id)" [class.disabled]="product?.is_locked" (click)="
                itemAddedToCart.get(product?.inventory_id)
                  ? goToCartWithEvent($event)
                  : addToCart($event, product)
              ">
              <div class="cart-content cart-content-add flex items-center gap-1 whitespace-nowrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"
                  class="cart-icon-svg flex-shrink-0 w-3 h-3 xl:w-5 xl:h-5">
                  <rect width="20" height="20" transform="translate(0.5)" fill="none" />
                  <path
                    d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
                    fill="white" />
                </svg>
                <span class="btn-text">Add to Cart</span>
              </div>
              <div class="cart-content cart-content-go flex items-center gap-1 whitespace-nowrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  class="cart-icon-svg flex-shrink-0 w-3 h-3 xl:w-5 xl:h-5">
                  <path
                    d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                    fill="white" />
                </svg>
                <span class="btn-text">Goto Cart</span>
              </div>
            </button>
          </div>
        </div>
      </article>
    </section>
  </div>
  <!-- list view of products -->
  <div class="ListView px-4 sm:px-8 lg:px-12 relative" *ngIf="selectedView === 'list' && productData.length > 0">
    <!-- Desktop / Tablet List View -->
    <ng-container *ngIf="!isMobile">
      <article
        class="list-card flex flex-nowrap items-stretch gap-3 lg:gap-5 mt-4 bg-white rounded-lg border border-transparent hover:border-gray-100 hover:shadow-md hover:bg-gray-50 cursor-pointer p-3 lg:p-4 overflow-hidden"
        *ngFor="let product of productData" [ngClass]="{ hidden: gridView }">
        <figure
          class="list-card__image overflow-hidden shrink-0 self-stretch bg-white rounded-lg w-[160px] md:w-[180px] lg:w-[240px] xl:w-[280px]">
          <div
            class="relative group w-full h-full min-h-[160px] md:min-h-[180px] lg:min-h-[200px] xl:min-h-[220px] cursor-pointer"
            (mouseenter)="onProductHover(product)" (mouseleave)="onProductHoverEnd()">
            <!-- Grade Badge -->
            <div *ngIf="product?.quality_s" [ngClass]="
                product?.quality_s === 'A'
                  ? 'bg-green-100 text-green-800'
                  : product?.quality_s === 'B'
                    ? 'bg-yellow-100 text-yellow-800'
                    : product?.quality_s === 'C'
                      ? 'bg-orange-100 text-orange-800'
                      : 'bg-green-100 text-green-800'
              " class="absolute top-2 left-2 z-10 flex items-center px-2 py-1 rounded shadow font-bold text-xs">
              <svg width="20" height="20" class="mr-1">
                <rect width="20" height="20" rx="4" [attr.fill]="
                    product?.quality_s === 'A'
                      ? '#01811D'
                      : product?.quality_s === 'B'
                        ? '#B8860B'
                        : product?.quality_s === 'C'
                          ? '#D35400'
                          : '#01811D'
                  " />
                <text x="10" y="15" text-anchor="middle" font-size="12" font-family="Arial, sans-serif" fill="white">
                  {{ product.quality_s }}
                </text>
              </svg>
              Quality
            </div>
            <div *ngIf="product?.stock_quantity_s <= 0"
              class="absolute gap-2 px-3 py-1 text-base font-bold leading-6 text-white rounded-lg opacity-80 bg-zinc-700 shadow-lg left-[101px] top-[100px] max-md:left-2/4 max-md:-translate-x-2/4 max-sm:left-2/4 max-sm:text-sm max-sm:-translate-x-2/4 md:left-[101px] md:top-[70px] lg:top-[100px] text-ellipsis-1-line">
              out of stock
            </div>

            <!-- Left Arrow -->
            <button *ngIf="
                hoveredProduct === product &&
                product?.part_image_path?.length > 1
              " (click)="prevImage(product)"
              class="absolute left-2 top-1/2 max-sm:top-1/3 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow group-hover:flex hidden">
              <svg width="24" height="24" fill="none" stroke="black" stroke-width="2">
                <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>

            <!-- Product Image -->
            <img [src]="getCurrentImage(product)" [alt]="product | productName" (click)="gotoProductDetails(product)"
              class="w-full h-full object-cover rounded" />

            <!-- Right Arrow -->
            <button *ngIf="
                hoveredProduct === product &&
                product?.part_image_path?.length > 1
              " (click)="nextImage(product)"
              class="absolute right-2 top-1/2 max-sm:top-1/3 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow group-hover:flex hidden">
              <svg width="24" height="24" fill="none" stroke="black" stroke-width="2">
                <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>

            <!-- Carousel Dots -->
            <div *ngIf="
                hoveredProduct === product &&
                product?.part_image_path?.length > 1
              "
              class="absolute bottom-2 max-sm:bottom-[70px] left-1/2 -translate-x-1/2 flex gap-1 z-10 group-hover:flex hidden">
              <span *ngFor="let img of product.images; let i = index" class="w-3 h-1.5 rounded-full" [ngClass]="{
                  'bg-gray-400': i !== product.currentImageIndex,
                  'bg-white border border-gray-400':
                    i === product.currentImageIndex,
                }"></span>
            </div>
          </div>
        </figure>

        <section class="ListDetails list-card__details flex flex-1 min-w-0 flex-col justify-between py-1 gap-2">
          <div class="ListDetails flex flex-col flex-1 min-w-0 gap-1 cursor-pointer">
            <section class="flex flex-col items-start w-full text-base gap-1"
              [ngClass]="{ 'gap-2': product?.part_type === 'Scrap Part' }">
              <span class="w-full text-sm md:text-base lg:text-lg font-bold leading-snug text-black line-clamp-2">
                {{ product | productName }}
              </span>
              <div class="text-black font-medium">
                <div class="flex flex-wrap items-center gap-1 text-sm text-gray-700 w-full">
                  <div class="text-sm mt-0.5 text-gray-400" *ngIf="product?.part_type === 'Used Part'">
                    {{ product?.make | slice: 0 : 10 }}
                    <span *ngIf="product?.model" class="text-gray-400">
                      •
                    </span>
                    <span class="text-gray-400 text-sm">{{
                      product?.model | slice: 0 : 8
                      }}</span>

                    <span *ngIf="product?.year_of_manufacture" class="text-gray-400">
                      •
                    </span>
                    <span class="text-sm text-gray-400">{{
                      product?.year_of_manufacture
                      }}</span>
                    <span *ngIf="product?.variant" class="text-gray-400">
                      •
                    </span>
                    <span class="text-sm text-gray-400">{{
                      product?.variant
                      }}</span>
                  </div>
                  <div class="text-sm mt-0.5 text-gray-400" *ngIf="product?.part_type === 'Scrap Part'">
                    {{ product?.material }}

                    <span class="text-black text-sm">{{
                      product?.model | slice: 0 : 8
                      }}</span>
                  </div>

                  <!-- <span class="text-gray-400">•</span> -->

                  <!-- <div class="text-sm mt-0.5">
                {{ product?.model }}
              </div>
                 <span class="text-gray-400">•</span>

              <div class="text-sm mt-0.5">
                {{ product?.year_of_manufacture }}
              </div> -->
                </div>
              </div>
              <div class="hidden md:flex gap-1 items-center">
                <span class="self-stretch my-auto font-medium text-neutral-500">
                  Seller :
                </span>
                <span class="self-stretch my-auto font-bold text-blue-950">
                  {{ product?.branch_code_s }}
                </span>
              </div>
              <!-- added keys for scrap  -->
              <div *ngIf="isScrapPart">
                <div class="flex flex-col gap-1 text-sm">
                  <!-- <p class="text-gray-600">
                Seller:
                <span
                  class="text-[#0A0A5F] text-[12px] font-bold leading-[16px]"
                  >RSF Thane,160047</span
                >
              </p> -->
                  <div class="flex items-center gap-2 flex-wrap">
                    <p class="text-black text-sm md:text-base font-bold leading-5">
                      ₹{{
                      product?.discounted_taxable
                      ? product?.discounted_taxable
                      : product?.taxable_amount
                      }}/<ng-container *ngIf="product.isOilProduct; else showKgPrice2">Liter</ng-container><ng-template
                        #showKgPrice2>Kg</ng-template>
                    </p>
                    <p class="text-[#777] line-through text-[12px] font-medium leading-[16px] max-sm:block"
                      *ngIf="product?.discount_percentage > 0">
                      ₹{{ product?.taxable_amount }}
                    </p>
                    <span *ngIf="product?.discount_percentage > 0"
                      class="flex items-center justify-center gap-1 p-[4px] rounded-[13px] bg-[#006C3B] text-white text-[10px] font-bold leading-[12.487px] whitespace-nowrap">
                      {{ product?.discount_percentage }}% off
                    </span>
                  </div>
                  <div class="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500">
                    <p>
                      Min Booking Qty:
                      <span class="text-black font-bold">
                        <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                          product?.min_quantity || product?.min_qty || 0
                          }}
                          kg</ng-container>
                        <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                          (product?.min_quantity || product?.min_qty || 0) / 1000
                          }}
                          ton</ng-container>
                        <ng-container *ngIf="product.selectedUnit === 'liter'">{{
                          product?.min_quantity || product?.min_qty || 0
                          }}
                          ltr</ng-container>
                      </span>
                    </p>
                    <p>
                      Max Booking Qty:
                      <span class="text-black font-bold">
                        <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                          product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                          product?.available_quantity || 0
                          }}
                          kg</ng-container>
                        <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                          ((product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                          product?.available_quantity || 0) / 1000)
                          }}
                          ton</ng-container>
                        <ng-container *ngIf="product.selectedUnit === 'liter'">{{
                          product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                          product?.available_quantity || 0
                          }}
                          ltr</ng-container>
                      </span>
                    </p>
                  </div>

                  <div
                    class="flex items-center border rounded-md overflow-hidden w-full max-w-[280px] lg:max-w-[320px]">
                    <!-- Quantity input/select based on unit -->
                    <div *ngIf="
                        !product.selectedUnit || product.selectedUnit === 'ton'
                      " class="flex flex-1 min-w-0">
                      <!-- Show select dropdown when not in custom mode -->
                      <select *ngIf="product.quantity !== 'custom'" (change)="onTonQuantitySelect(product, $event)"
                        [value]="product.quantity || ''"
                        class="px-2 lg:px-3 py-2 text-sm w-full min-w-0 border-none focus:outline-none appearance-none bg-transparent">
                        <option value="">Select any one</option>
                        <option value="10" *ngIf="!product.isOilProduct">
                          10
                        </option>
                        <option value="15" *ngIf="!product.isOilProduct">
                          15
                        </option>
                        <option value="20" *ngIf="!product.isOilProduct">
                          20
                        </option>
                        <option value="25" *ngIf="!product.isOilProduct">
                          25
                        </option>
                        <option value="50" *ngIf="!product.isOilProduct">
                          50
                        </option>
                        <option value="custom" *ngIf="!product.isOilProduct">
                          Custom
                        </option>
                      </select>
                      <!-- Show input field when custom is selected -->
                      <input *ngIf="product.quantity === 'custom'" type="number" placeholder="Enter custom quantity"
                        [value]="product.customTonQuantity || ''" (input)="onCustomTonQuantityInput(product, $event)"
                        (blur)="onQuantityBlur(product)" [id]="'customInput-' + product.part_number"
                        class="px-2 lg:px-3 py-2 text-sm w-full min-w-0 border-none focus:outline-none appearance-none bg-transparent"
                        min="1" step="0.1" #customInput />
                    </div>

                    <div *ngIf="product.selectedUnit === 'kg'" class="flex flex-1 min-w-0">
                      <input type="number" placeholder="Enter quantity" [value]="product.customKgQuantity || ''"
                        (input)="onKgQuantityChange(product, $event)" (blur)="onQuantityBlur(product)"
                        class="px-2 lg:px-3 py-2 text-sm w-full border-none focus:outline-none bg-transparent" />
                    </div>

                    <div *ngIf="product.selectedUnit === 'liter'" class="flex flex-1 min-w-0">
                      <input type="number" placeholder="Enter quantity" [value]="product.customLiterQuantity || ''"
                        (input)="onLiterQuantityChange(product, $event)" (blur)="onQuantityBlur(product)"
                        class="px-2 lg:px-3 py-2 text-sm w-full border-none focus:outline-none bg-transparent" />
                    </div>

                    <!-- Divider -->
                    <div class="unit-divider"></div>

                    <!-- Unit select -->
                    <select (change)="onUnitChange(product, $event)" [value]="product.selectedUnit || 'ton'"
                      class="px-2 py-2 text-sm shrink-0 w-[68px] sm:w-[72px] min-w-[68px] sm:min-w-[72px] border-none focus:outline-none appearance-none bg-transparent cursor-pointer">
                      <option value="ton" *ngIf="!product.isOilProduct">
                        ton
                      </option>
                      <option value="kg" *ngIf="!product.isOilProduct">
                        kg
                      </option>
                      <option value="liter" *ngIf="product.isOilProduct">
                        ltr
                      </option>
                    </select>
                  </div>

                  <!-- Error message for quantity validation -->
                  <!-- Error message for quantity validation -->
                  <div class="w-full max-w-[320px]">
                    <div *ngIf="
                        product.quantityTouched &&
                        (isScrapPart || product?.part_type === 'Scrap Part') &&
                        (getSelectedQuantity(product) === 0 ||
                          getSelectedQuantity(product) === null ||
                          getSelectedQuantity(product) === undefined)
                      " class="mt-2 text-[10px] sm:text-xs text-red-600">
                      Please select a quantity
                    </div>
                    <div *ngIf="
                        product.quantityTouched &&
                        getSelectedQuantity(product) > 0 &&
                        getSelectedQuantity(product) <
                          (product.min_quantity || product.min_qty || 0)
                      " class="mt-2 text-[10px] sm:text-xs text-red-600">
                      Minimum quantity is
                      <ng-container *ngIf="
                          product.selectedUnit === 'kg' || !product.selectedUnit
                        ">{{
                        product.min_quantity || product.min_qty || 0
                        }}
                        kg</ng-container><ng-container *ngIf="product.selectedUnit === 'ton'">{{
                        (product.min_quantity || product.min_qty || 0) / 1000
                        }}
                        ton</ng-container><ng-container *ngIf="
                          product.selectedUnit === 'liter' ||
                          product.isOilProduct
                        ">{{
                        product.min_quantity || product.min_qty || 0
                        }}
                        ltr</ng-container>
                    </div>
                    <div *ngIf="
                        product.quantityTouched &&
                        getSelectedQuantity(product) > 0 &&
                        getSelectedQuantity(product) >
                          (product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity || product.available_quantity || 0)
                      " class="mt-2 text-[10px] sm:text-xs text-red-600">
                      Maximum available quantity is
                      <ng-container *ngIf="
                          product.selectedUnit === 'kg' || !product.selectedUnit
                        ">{{ product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                        product.available_quantity || 0 }} kg</ng-container><ng-container
                        *ngIf="product.selectedUnit === 'ton'">{{
                        ((product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                        product.available_quantity || 0) / 1000)
                        }}
                        ton</ng-container><ng-container *ngIf="
                          product.selectedUnit === 'liter' ||
                          product.isOilProduct
                        ">{{ product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                        product.available_quantity || 0 }} ltr</ng-container>
                    </div>
                  </div>
                </div>
                <div
                  class="flex justify-between items-center max-w-full font-bold min-h-[25px] text-blue-950 w-[421px] hidden sm:block">
                  <p class="flex-1 shrink gap-2 self-stretch my-auto w-full basis-0 min-w-60 max-md:max-w-full">
                    Store pickup or Delivery by
                    {{ getDeliveryDate() }}
                  </p>
                </div>
              </div>
            </section>
            <!-- 
            <div *ngIf="!isScrapPart">
              <section
                class="flex flex-col mt-0 sm:mt-1 w-full max-md:max-w-full mobile-price"
              >
                <div class="self-start min-h-14">
                  <div class="flex gap-2 items-center font-bold min-h-8">
                    <p
                      class="text-base font-bold text-black max-sm:text-base whitespace-nowrap"
                    >
                      ₹{{
                        product.discounted_price
                          ? product.discounted_price
                          : product.price_s
                            ? product.price_s
                            : 0
                      }}
                    </p>
                    <p
                      lass="text-base font-medium line-through text-neutral-500 max-sm:text-xs whitespace-nowrap"
                    >
                      <span
                        style="text-decoration: line-through"
                        *ngIf="
                          product.discount_percentage &&
                          product?.discount_percentage > 0
                        "
                      >
                        ₹{{ product.price_s }}</span
                      >
                    </p>
                    <p
                      class="px-2 py-1 h-6 text-xs font-bold text-white bg-emerald-800 rounded-2xl max-sm:text-[10px] max-sm:h-5 max-sm:py-0 max-sm:px-1 whitespace-nowrap"
                      *ngIf="
                        product?.discount_percentage &&
                        product?.discount_percentage > 0
                      "
                    >
                      {{ product?.discount_percentage }}% Off
                    </p>
                  </div>
                  <p
                    class="hidden md:flex mt-1 text-sm font-medium leading-none text-blue-950"
                  >
                    (Inclusive all taxes)
                  </p>
                </div>
              </section>
              <section
                class="mt-2 w-full text-base max-md:max-w-full mobile-delivery"
                *ngIf="!isMobile"
              >
                <div
                  class="flex justify-between items-center max-w-full font-bold min-h-[25px] text-blue-950 w-[421px]"
                >
                  <p
                    class="flex-1 shrink gap-2 self-stretch my-auto w-full basis-0 min-w-60 max-md:max-w-full"
                  >
                    Store pickup or Delivery by
                    {{ getDeliveryDate() }}
                  </p>
                </div>
                <div
                  class="flex flex-wrap gap-2 items-center mt-1 w-full max-md:max-w-full"
                >
                  <p class="self-stretch text-sm my-auto text-neutral-500">
                    Delivery Fee ₹ 500{{ product.deliveryFee }}
                  </p>
                  <img
                    [src]="product.dividerIcon"
                    class="object-contain shrink-0 self-stretch w-0 aspect-[0.04] stroke-[1px] stroke-neutral-300"
                  />
                  <div
                    class="flex gap-1 items-center self-stretch my-auto text-black"
                  >
                    <span class="self-stretch text-sm my-auto"
                      >Open Box Delivery</span
                    >
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/0c3f00a9f5eeb59e31a86117b844ede64c1f62a5?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                      class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                      alt="Open box delivery icon"
                    />
                  </div>
                </div>
              </section>
            </div> -->
            <div *ngIf="product?.is_locked"
              class="flex items-center gap-2 text-[#E30613] text-[12px] font-bold max-md:text-[10px]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16">
                <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />
                <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />
                <circle cx="16" cy="23" r="2" fill="red" />
              </svg>
              <span>This part is no longer available for purchase.</span>
            </div>
          </div>
        </section>

        <aside
          class="buyButtonList list-card__actions w-[180px] md:w-[200px] lg:w-[240px] xl:w-[280px] shrink-0 flex flex-col relative">
          <!-- Share icon top-right -->
          <img *ngIf="!isMobile" (click)="openSocialSharePopup()"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/f289db56885bc1a5dfb6cab28082c95158b21f80?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
            class="absolute top-0 right-0 w-6 h-6 lg:w-7 lg:h-7 cursor-pointer z-10" alt="Share icon" />

          <section class="w-full text-base font-bold text-center flex flex-col gap-2 pr-0 pt-7 lg:pt-8">
            <app-buy-now-button *ngIf="!isMobile" [productData]="product" [isLocked]="product?.is_locked"
              (buyNowClicked)="onBuyNow(product)" (paymentSuccess)="onPaymentSuccess($event)" class="w-full font-bold">
            </app-buy-now-button>

            <button *ngIf="!isMobile" [disabled]="product?.is_locked"
              class="cart-btn flex items-center justify-center gap-1 p-2 w-full text-white bg-blue-500 rounded-lg min-h-9 lg:min-h-10 text-xs lg:text-sm"
              [class.added]="itemAddedToCart.get(product?.inventory_id)" [class.disabled]="product?.is_locked" (click)="
                itemAddedToCart.get(product?.inventory_id)
                  ? goToCartWithEvent($event)
                  : addToCart($event, product)
              ">
              <div class="cart-content cart-content-add">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"
                  class="cart-icon-svg w-4 h-4 lg:w-5 lg:h-5">
                  <rect width="20" height="20" transform="translate(0.5)" fill="none" />
                  <path
                    d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
                    fill="white" />
                </svg>
                <span class="btn-text text-xs lg:text-sm font-bold text-white">Add to Cart</span>
              </div>
              <div class="cart-content cart-content-go">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  class="cart-icon-svg w-4 h-4 lg:w-5 lg:h-5">
                  <path
                    d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                    fill="white" />
                </svg>
                <span class="btn-text text-xs lg:text-sm font-bold text-white">Go to Cart</span>
              </div>
            </button>
          </section>

          <!-- Exchange offer -->
          <div class="flex items-center w-full mt-3" *ngIf="!isMobile && product?.part_type === 'Used Part'">
            <section
              class="flex overflow-hidden flex-col justify-center p-2 w-full bg-white rounded-md border border-gray-200 text-neutral-900">
              <div class="flex gap-2 items-start">
                <div class="flex shrink-0 w-5 h-5">
                  <input type="checkbox" class="w-3 h-3 rounded border border-gray-200 cursor-pointer"
                    aria-label="Exchange old part option" />
                </div>
                <div class="flex flex-col justify-center text-left">
                  <span class="text-xs lg:text-sm font-bold leading-snug">
                    Exchange old part for upto ₹{{ product.exchangeValue }}off
                  </span>
                  <p class="mt-1 text-[10px] lg:text-xs font-medium leading-snug text-neutral-500">
                    The price will be finalised after inspection
                  </p>
                </div>
              </div>
            </section>
          </div>

          <!-- <section
            class="flex flex-col mt-1 w-full text-neutral-900"
            *ngIf="!isMobile && product?.part_type === 'Scrap Part'"
          >
            <div class="flex items-center justify-between w-full gap-2">
              <span class="text-xs text-gray-500">Booking Amount</span>
              <span class="text-sm lg:text-base font-semibold text-gray-800">
                ₹{{ product.booking_amount }}
              </span>
            </div>
            <p class="text-xs lg:text-sm text-[#1b1464] mt-1 text-left">
              The balance amount of ₹{{ product.booking_amount }} is to be paid
              at the time of store pickup.
            </p>
          </section> -->

          <section class="mt-2 w-full text-xs lg:text-sm font-bold leading-snug text-black" *ngIf="!isMobile">
            <ul class="w-full space-y-2">
              <li class="flex gap-2 items-start">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/7a6daec8b49ee4bed6c1e72abb37b2d3e3bb747b?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  class="object-contain shrink-0 w-4 lg:w-5 aspect-square mt-0.5" alt="Offer icon" />
                <p class="flex-1 text-left">
                  Get it for as low as
                  <span style="color: rgba(0, 108, 59, 1)">₹22,500,</span>
                  Extra 5% OFF
                </p>
              </li>
              <li class="text-left">
                <button type="button" class="text-[#307FE1] text-xs lg:text-sm font-bold">
                  + 2 more offers Available
                </button>
              </li>
            </ul>
          </section>
        </aside>
      </article>
    </ng-container>

    <!-- Mobile List View -->
    <ng-container *ngIf="isMobile">
      <article
        class="flex flex-col gap-3 mt-4 bg-white rounded-lg border border-gray-200 p-3 cursor-pointer hover:shadow-sm"
        *ngFor="let product of productData">
        <div class="flex gap-3">
          <!-- Product Image -->
          <div class="relative flex-shrink-0 w-[130px] h-[130px] rounded-lg overflow-hidden">
            <div class="relative w-full h-full" (mouseenter)="onProductHover(product)"
              (mouseleave)="onProductHoverEnd()">
              <!-- Grade Badge -->
              <div *ngIf="product?.quality_s" [ngClass]="
                  product?.quality_s === 'A'
                    ? 'bg-green-100 text-green-800'
                    : product?.quality_s === 'B'
                      ? 'bg-yellow-100 text-yellow-800'
                      : product?.quality_s === 'C'
                        ? 'bg-orange-100 text-orange-800'
                        : 'bg-green-100 text-green-800'
                "
                class="absolute top-1 left-1 z-10 flex items-center px-1.5 py-0.5 rounded shadow text-[8px] font-bold">
                <svg width="12" height="12" class="mr-0.5">
                  <rect width="12" height="12" rx="2" [attr.fill]="
                      product?.quality_s === 'A'
                        ? '#01811D'
                        : product?.quality_s === 'B'
                          ? '#B8860B'
                          : product?.quality_s === 'C'
                            ? '#D35400'
                            : '#01811D'
                    " />
                  <text x="6" y="9" text-anchor="middle" font-size="8" font-family="Arial, sans-serif" fill="white">
                    {{ product.quality_s }}
                  </text>
                </svg>
                Quality
              </div>

              <div *ngIf="product?.stock_quantity_s <= 0"
                class="absolute inset-0 flex items-center justify-center bg-zinc-700 bg-opacity-80 rounded-lg">
                <span class="text-white text-xs font-bold">Out of stock</span>
              </div>

              <img [src]="getCurrentImage(product)" [alt]="product | productName" (click)="gotoProductDetails(product)"
                class="w-full h-full object-cover" />
            </div>
          </div>

          <!-- Product Details -->
          <div class="flex-1 flex flex-col gap-1.5 min-w-0">
            <!-- Product Name -->
            <h3 (click)="gotoProductDetails(product)"
              class="text-base font-bold text-black leading-tight line-clamp-2 cursor-pointer line-clamp-1">
              {{ product | productName }}
            </h3>

            <!-- Material/Category -->
            <p class="text-xs text-gray-600">
              {{ product?.scrap_category || product?.material }}
            </p>
            <!-- <p class="text-xs text-gray-600" *ngIf="!isScrapPart">
              {{ product?.make }} • {{ product?.model }}
            </p> -->

            <!-- Seller Info -->
            <p class="text-xs text-gray-600">
              Seller :
              <span class="text-[#0A0A5F] font-bold">{{
                product?.seller_name || product?.branch_code_s
                }}</span>
            </p>

            <!-- Pricing -->
            <div class="flex items-center gap-2 flex-wrap">
              <span class="text-base font-bold text-black">
                ₹{{
                product?.discounted_price
                ? product?.discounted_price.toLocaleString()
                : product?.price_s?.toLocaleString()
                }}/<ng-container *ngIf="product.isOilProduct; else showKgPriceMobile">Liter</ng-container><ng-template
                  #showKgPriceMobile>Kg</ng-template>
              </span>
              <span *ngIf="
                  product?.discounted_price &&
                  product?.price_s &&
                  product?.discount_percentage > 0
                " class="text-xs line-through text-gray-500">
                ₹{{ product?.price_s?.toLocaleString() }}
              </span>
              <span *ngIf="
                  product?.discounted_price &&
                  product?.price_s &&
                  product?.discount_percentage > 0
                " class="px-2 py-0.5 text-[10px] font-bold text-white bg-[#006C3B] rounded-full">
                {{ product?.discount_percentage }}% Off
              </span>
            </div>

            <!-- Min & Max Order Qty -->
            <div class="flex flex-wrap items-center justify-between gap-1 text-xs text-gray-500">
              <p>
                Min Booking Qty :
                <span class="text-black font-bold">
                  <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                    product?.min_quantity || product?.min_qty || 0
                    }}
                    kg</ng-container>
                  <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                    (product?.min_quantity || product?.min_qty || 0) / 1000
                    }}
                    ton</ng-container>
                  <ng-container *ngIf="product.selectedUnit === 'liter'">{{
                    product?.min_quantity || product?.min_qty || 0
                    }}
                    ltr</ng-container>
                </span>
              </p>
              <p>
                Max Booking Qty :
                <span class="text-black font-bold">
                  <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                    product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                    product?.available_quantity || 0
                    }}
                    kg</ng-container>
                  <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                    ((product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                    product?.available_quantity || 0) / 1000)
                    }}
                    ton</ng-container>
                  <ng-container *ngIf="product.selectedUnit === 'liter'">{{
                    product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                    product?.available_quantity || 0
                    }}
                    ltr</ng-container>
                </span>
              </p>
            </div>
          </div>
        </div>

        <!-- Quantity Selector (only for scrap parts) -->
        <div class="flex flex-col gap-2">
          <div class="product-card-qty-box">
            <!-- Quantity input/select based on unit -->
            <div *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'" class="flex flex-1 min-w-0">
              <!-- Show select dropdown when not in custom mode -->
              <select *ngIf="product.quantity !== 'custom'" (change)="onTonQuantitySelect(product, $event)"
                [value]="product.quantity || ''"
                class="qty-dropdown">
                <option value="">Select any one</option>
                <option value="10" *ngIf="!product.isOilProduct">10</option>
                <option value="15" *ngIf="!product.isOilProduct">15</option>
                <option value="20" *ngIf="!product.isOilProduct">20</option>
                <option value="25" *ngIf="!product.isOilProduct">25</option>
                <option value="50" *ngIf="!product.isOilProduct">50</option>
                <option value="custom" *ngIf="!product.isOilProduct">
                  Custom
                </option>
              </select>
              <!-- Show input field when custom is selected -->
              <input *ngIf="product.quantity === 'custom'" type="number" placeholder="Enter custom quantity"
                [value]="product.customTonQuantity || ''" (input)="onCustomTonQuantityInput(product, $event)"
                (blur)="onQuantityBlur(product)" [id]="'customInput-mobile-' + product.part_number"
                class="qty-input" min="1" step="0.1" />
            </div>

            <div *ngIf="product.selectedUnit === 'kg'" class="flex flex-1 min-w-0">
              <input type="number" placeholder="Enter quantity" [value]="product.customKgQuantity || ''"
                (input)="onKgQuantityChange(product, $event)" (blur)="onQuantityBlur(product)"
                class="qty-input" />
            </div>

            <div *ngIf="product.selectedUnit === 'liter'" class="flex flex-1 min-w-0">
              <input type="number" placeholder="Enter quantity" [value]="product.customLiterQuantity || ''"
                (input)="onLiterQuantityChange(product, $event)" (blur)="onQuantityBlur(product)"
                class="qty-input" />
            </div>

            <!-- Divider -->
            <div class="unit-divider"></div>

            <!-- Unit select -->
            <select (change)="onUnitChange(product, $event)" [value]="product.selectedUnit || 'ton'"
              class="unit-dropdown">
              <option value="ton" *ngIf="!product.isOilProduct">ton</option>
              <option value="kg" *ngIf="!product.isOilProduct">kg</option>
              <option value="liter" *ngIf="product.isOilProduct">ltr</option>
            </select>
          </div>

          <!-- Error message for quantity validation -->
          <div class="w-full">
            <span *ngIf="
                product.quantityTouched &&
                (isScrapPart || product?.part_type === 'Scrap Part') &&
                (getSelectedQuantity(product) === 0 ||
                  getSelectedQuantity(product) === null ||
                  getSelectedQuantity(product) === undefined)
              " class="block text-[10px] text-red-600">
              Please select a quantity
            </span>
            <span *ngIf="
                product.quantityTouched &&
                getSelectedQuantity(product) > 0 &&
                getSelectedQuantity(product) <
                  (product.min_quantity || product.min_qty || 0)
              " class="block text-[10px] text-red-600">
              Minimum quantity is
              <ng-container *ngIf="product.selectedUnit === 'kg' || !product.selectedUnit">{{
                product.min_quantity || product.min_qty || 0
                }}
                kg</ng-container><ng-container *ngIf="product.selectedUnit === 'ton'">{{
                (product.min_quantity || product.min_qty || 0) / 1000
                }}
                ton</ng-container><ng-container *ngIf="product.selectedUnit === 'liter' || product.isOilProduct">{{
                product.min_quantity || product.min_qty || 0
                }}
                ltr</ng-container>
            </span>
            <span *ngIf="
                product.quantityTouched &&
                getSelectedQuantity(product) > 0 &&
                getSelectedQuantity(product) > (product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity || product.available_quantity || 0)
              " class="block text-[10px] text-red-600">
              Maximum available quantity is
              <ng-container *ngIf="product.selectedUnit === 'kg' || !product.selectedUnit">{{ product?.max_booking_qty
                || product?.max_booking_quantity || product?.max_quantity || product.available_quantity || 0 }}
                kg</ng-container><ng-container *ngIf="product.selectedUnit === 'ton'">{{
                ((product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                product.available_quantity || 0) / 1000)
                }}
                ton</ng-container><ng-container *ngIf="product.selectedUnit === 'liter' || product.isOilProduct">{{
                product?.max_booking_qty || product?.max_booking_quantity || product?.max_quantity ||
                product.available_quantity || 0 }} liter</ng-container>
            </span>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex gap-2 mt-2">
          <!-- Book Now Button -->
          <app-buy-now-button [productData]="product" [isLocked]="product?.is_locked"
            (buyNowClicked)="onBuyNow(product)" (paymentSuccess)="onPaymentSuccess($event)" class="flex-1">
          </app-buy-now-button>

          <!-- Animated Cart Button -->
          <button [disabled]="product?.is_locked"
            class="cart-btn w-full flex items-center justify-center gap-1 p-2.5 text-[12px] text-white bg-blue-500 rounded-lg border border-[#307FE1]"
            [class.added]="itemAddedToCart.get(product?.inventory_id)" [class.disabled]="product?.is_locked" (click)="
              itemAddedToCart.get(product?.inventory_id)
                ? goToCartWithEvent($event)
                : addToCart($event, product)
            ">
            <div class="cart-content cart-content-add">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 21 20" fill="none"
                class="cart-icon-svg w-4 h-4">
                <rect width="20" height="20" transform="translate(0.5)" fill="none" />
                <path
                  d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
                  fill="white" />
              </svg>
              <span class="btn-text text-[12px] font-bold text-white">Add to Cart</span>
            </div>
            <div class="cart-content cart-content-go">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none"
                class="cart-icon-svg w-4 h-4">
                <path
                  d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                  fill="white" />
              </svg>
              <span class="btn-text text-[12px] font-bold text-white">Go to Cart</span>
            </div>
          </button>
        </div>

        <!-- Locked Message -->
        <div *ngIf="product?.is_locked" class="flex items-center gap-2 text-[#E30613] text-xs font-bold">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="12" height="12">
            <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />
            <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />
            <circle cx="16" cy="23" r="2" fill="red" />
          </svg>
          <span>This part is no longer available for purchase.</span>
        </div>
      </article>
    </ng-container>
  </div>

  <div class="flex justify-center tes items-center" *ngIf="products.length === 0 && !isLoading">
    No Result found
  </div>

  <div class="w-full flex justify-center py-8 relative" *ngIf="productData && products.length > 0 && showPagination">
    <!-- Pagination -->
    <app-pagination [currentPage]="currentPageValue" [totalPages]="totalPagesValue" [isVisible]="showPagination"
      [totalPages]="totalPagesValue" (pageChange)="handlePageChange($event)">
    </app-pagination>
  </div>

  <!-- Buy Now Popup -->
  <app-buy-now-popup *ngIf="isBuyNowPopupOpen && selectedProductForBuyNow" [productData]="selectedProductForBuyNow"
    [isOpen]="isBuyNowPopupOpen" [quantity]="getQuantityForPopup(selectedProductForBuyNow)" [unit]="
      selectedProductForBuyNow?.selectedUnit === 'kg'
        ? 'Kg'
        : selectedProductForBuyNow?.selectedUnit === 'liter'
          ? 'Litr'
          : 'Ton'
    " (close)="closeBuyNowPopup()" (paymentSuccess)="onPaymentSuccess($event)">
  </app-buy-now-popup>

  <!-- Modal -->
  <div *ngIf="isSocialShareOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white w-full max-w-2xl rounded-lg shadow-lg p-6 relative">
      <!-- Close Button -->
      <button (click)="closeSocialSharePopup()" class="absolute top-3 right-3">
        <!-- <img src="/src/assets/location.png"alt="Close" class="w-5 h-5" /> -->
        X
      </button>

      <!-- Modal Header -->
      <div class="text-lg font-semibold mb-4 text-center">
        Share this product
      </div>

      <!-- Social Icons -->
      <div class="flex justify-around items-center gap-4 py-4">
        <a title="Facebook" href="https://www.facebook.com/sharer.php?u={{ pageURL }}" target="_blank"
          rel="noopener noreferrer" class="hover:opacity-80 transition-opacity">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#1877F2" viewBox="0 0 24 24">
            <path
              d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        </a>
        <a title="WhatsApp" href="https://wa.me?text={{ pageURL }}" target="_blank" rel="noopener noreferrer"
          class="hover:opacity-80 transition-opacity">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#25D366" viewBox="0 0 24 24">
            <path
              d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
        </a>
        <a title="Instagram" href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"
          class="hover:opacity-80 transition-opacity">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#E4405F" viewBox="0 0 24 24">
            <path
              d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        </a>
        <a title="Twitter" href="https://twitter.com/intent/tweet?url={{ pageURL }}" target="_blank"
          rel="noopener noreferrer" class="hover:opacity-80 transition-opacity">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#1DA1F2" viewBox="0 0 24 24">
            <path
              d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
          </svg>
        </a>
        <a title="Mail" href="mailto:?subject=Link&body={{ pageURL }}" target="_blank" rel="noopener noreferrer"
          class="hover:opacity-80 transition-opacity">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#EA4335" viewBox="0 0 24 24">
            <path
              d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z" />
          </svg>
        </a>
        <button (click)="copyMessage()" title="Copy link" class="hover:opacity-80 transition-opacity">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="#666" viewBox="0 0 24 24">
            <path
              d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Scrap Certificate Modal -->
<app-scrap-certificate-modal></app-scrap-certificate-modal>